// Async boundary for Module Federation.
//
// Dynamically importing the real entry (./bootstrap) defers all shared-module
// resolution (react, react-dom, react-router-dom) until after webpack's
// federation runtime has initialized. This is the documented fix for the
// "Shared module is not available for eager consumption" error and lets us
// keep eager: false on shared deps (smaller initial bundle).
//
// See: packages/cwic-lounge/docs/MODULE-FEDERATION.md
import('./bootstrap')
